import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mobileHeader: {
    display: 'none',
    position: 'fixed',
    backgroundColor: theme.palette.background.paper,
    top: 0,
    left: 0,
    right: 0,
    height: 56,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px',
    borderBottom: '1px solid rgba(126, 69, 52, 0.2)',

    [theme.breakpoints.down('sm')]: {
      display: 'flex'
    }
  },

  menuButton: {
    background: 'transparent',
    border: 'none',
    padding: 8,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#7E4534',
    position: 'absolute',
    left: 8,
    '& svg': {
      fontSize: '1.5rem'
    }
  },

  logo: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 900,
    fontSize: theme.app.typography.h3.fontSize,
    lineHeight: '150%',
    color: '#7E4534',
    textDecoration: 'none',
    flex: 'none',
    flexGrow: 0,
    '&:hover': {
      opacity: 0.8
    }
  },

  logoContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    lineHeight: 1
  },

  farmName: {
    fontSize: 10,
    color: '#7E4534',
    fontFamily: 'Open Sans',
    fontWeight: 400,
    opacity: 0.7,
    maxWidth: 160,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const
  },

  userAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    backgroundColor: '#543936',
    borderRadius: '50%',
    color: theme.palette.secondary.main,
    fontWeight: 700,
    fontSize: theme.app.typography.body.fontSize,
    fontFamily: 'Poppins',
    textDecoration: 'none',
    cursor: 'pointer',
    position: 'absolute',
    right: 16,
    '&:hover': {
      backgroundColor: '#6B4A46'
    }
  }
}))
